(function () {
  angular
    .module("akitabox.room.list")
    .controller("RoomListController", RoomListController);

  /* @ngInject */
  function RoomListController(
    $scope,
    $location,
    $state,
    models,
    building,
    organization,
    query,
    RoomService
  ) {
    var self = this;

    var filter = RoomService.getBuildingListFilter(building._id) || {};
    var baseQuery = {
      include_values: true,
    };

    self.searchText = null;
    self.building = building;
    self.rooms = null;
    self.organization = organization;

    self.hasLoaded = hasLoaded;
    self.emptyList = emptyList;
    self.selectRoom = selectRoom;
    self.addWorkOrder = addWorkOrder;
    self.addServiceRequest = addServiceRequest;

    init();

    function init() {
      // Initialize search. Default to querystring, then cached filter
      self.searchText = query ? query : filter.q;
      fetchRooms(self.searchText);
      self.searchOpen = !angular.isEmpty(self.searchText);
      // Watch search text
      $scope.$watch("vm.searchText", angular.debounce(onSearchChangeText, 500));
    }

    function addServiceRequest() {
      var params = {};

      params[models.BUILDING.ROUTE_SINGULAR] = self.building._id;

      $state.go("app.serviceRequests.create", params);
    }

    function addWorkOrder() {
      var params = {};

      params[models.BUILDING.ROUTE_SINGULAR] = self.building._id;

      $state.go("app.workOrders.create", params);
    }

    function onSearchChangeText(newValue, oldValue) {
      if (newValue !== oldValue && !angular.isEmpty(newValue)) {
        fetchRooms(newValue);
      } else if (newValue !== oldValue) {
        fetchRooms();
      }
    }

    function updateFilter(params) {
      filter = angular.extend(filter, params);
      RoomService.setBuildingListFilter(building._id, filter);
    }

    function fetchRooms(text) {
      $location.search("q", text);
      if (text) {
        // New filter option for BFF
        updateFilter({ $or: `name=${text};number=${text}` });
      } else {
        if (filter) {
          // Cleaning filter to avoid cached data filtered
          filter = {};
        }
      }

      var additionalParams = { building: building._id };
      var params = angular.extend({}, baseQuery, filter, additionalParams);

      var options = {
        includePinType: true,
      };
      self.rooms = RoomService.getVirtualRepeat(
        building._id,
        100,
        params,
        options,
        self.organization._id
      );
    }

    function selectRoom(room) {
      $state.go("app.building.room.detail", { roomId: room._id });
    }

    function hasLoaded() {
      return angular.isNumber(self.rooms.numItems);
    }

    function emptyList() {
      return (
        self.rooms.getLength() === 0 &&
        !self.rooms.moreToLoad &&
        !self.rooms.fetching
      );
    }
  }
})();
